<template>
  <main class="min-h-screen flex items-center justify-center bg-black px-6 text-white">
    <section class="max-w-xl">
      <p class="text-sm uppercase tracking-widest text-gray-400">404</p>
      <h1 class="mt-4 text-4xl font-bold">Page not found</h1>
      <p class="mt-6 text-gray-300">This page does not exist or may have moved.</p>
      <a href="/" class="mt-8 inline-block rounded-full border border-white px-6 py-3">
        Back to portfolio
      </a>
    </section>
  </main>
</template>

<script>
export default {
  name: "NotFoundPage",
};
</script>
